module.exports = __webpack_public_path__ + "img/icon-dne-token.34bca7f6.svg";